export default __webpack_public_path__ + "static/media/analytics.05b06800.png";